import { createRouter } from '@tanstack/react-router';
import { tree } from './tree';

const router = createRouter({
  routeTree: tree,
  notFoundMode: 'root',
  defaultPreload: 'intent',
});

export { router };
